const config = {
   
    // blogApiUrl: 'http://api.localbigsauda.com/v1/',
    // uploadUrl: 'http://upload.localbigsauda.com/'
    blogApiUrl: 'https://api.bigsauda.com/v1/',
    uploadUrl: 'http://uploads.bigsauda.com'

};

export default config;